const ReadOnlyMetadataItem = ({
  keyName,
  value,
}: {
  keyName: string;
  value: any;
}) =>
  keyName !== "markdown_enabled" && (
    <div className="mb-1">
      <span className="font-semibold">{keyName}:</span>{" "}
      {typeof value === "object" ? JSON.stringify(value) : value}
    </div>
  );

export default ReadOnlyMetadataItem;
